import { useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Apiservice from "../Apiservice";

const QuizAdd = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const acadamicId = location.state?.acadamicId;
    const acadamic = location.state?.acadamic;

    const descriptionRef = useRef("");
    const quizNameRef = useRef("");

    const [loading, setLoading] = useState(false);

    const [quizProfileImage, setQuizProfileImage] = useState(null);
    const [quizVideo, setQuizVideo] = useState(null);

    const handleQuizAdd = async () => {
        try {
            if (!quizNameRef.current.value) {
                alert("Please enter quiz name");
                return;
            }

            setLoading(true);

            const formData = new FormData();

            formData.append("academicId", acadamicId);
            formData.append("name", quizNameRef.current.value);
            formData.append(
                "description",
                descriptionRef.current.value
            );

            if (quizProfileImage) {
                formData.append("profileImage", quizProfileImage);
            }

            if (quizVideo) {
                formData.append("video", quizVideo);
            }
             const token = localStorage.getItem("access_token");
            const headers = { access_token: token };
            const result = await Apiservice.ExamAdd(formData, headers);

            if (result.success) {
                alert("Quiz Added Successfully");
                navigate("/quizlist");
            } else {
                alert(result.message);
            }
        } catch (error) {
            console.log(error);
            alert("Something went wrong");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div
            className="container-fluid py-4 px-3"
            style={{
                background: "#f4f6f9",
                minHeight: "100vh",
            }}
        >
            <div className="row justify-content-center">
                <div className="col-12 col-md-10 col-lg-7">
                    <div
                        className="card border-0 shadow-sm"
                        style={{
                            borderRadius: "20px",
                            overflow: "hidden",
                        }}
                    >
                        {/* Header */}
                        <div
                            className="text-center py-4"
                            style={{
                                background:
                                    "linear-gradient(135deg, #0d6efd, #0b5ed7)",
                                color: "#fff",
                            }}
                        >
                            <h3
                                style={{
                                    fontWeight: "700",
                                    marginBottom: "5px",
                                }}
                            >
                                Add Quiz
                            </h3>

                            <p
                                style={{
                                    margin: 0,
                                    opacity: 0.9,
                                    fontSize: "14px",
                                }}
                            >
                                Create and manage quiz topics
                            </p>
                        </div>

                        {/* Body */}
                        <div className="card-body p-4">

                            {/* Academic */}
                            <div className="mb-3">
                                <label
                                    className="form-label fw-semibold"
                                >
                                    Academic
                                </label>

                                <input
                                    type="text"
                                    className="form-control"
                                    value={acadamic || ""}
                                    disabled
                                />
                            </div>

                            {/* Quiz Name */}
                            <div className="mb-3">
                                <label
                                    className="form-label fw-semibold"
                                >
                                    Quiz Name
                                </label>

                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter quiz name"
                                    ref={quizNameRef}
                                />
                            </div>

                            {/* Description */}
                            <div className="mb-3">
                                <label
                                    className="form-label fw-semibold"
                                >
                                    Description
                                </label>

                                <textarea
                                    className="form-control"
                                    rows={4}
                                    placeholder="Enter description"
                                    ref={descriptionRef}
                                ></textarea>
                            </div>

                            {/* Profile Image */}
                            <div className="mb-3">
                                <label
                                    className="form-label fw-semibold"
                                >
                                    Profile Image
                                </label>

                                <input
                                    type="file"
                                    className="form-control"
                                    accept="image/*"
                                    onChange={(e) =>
                                        setQuizProfileImage(
                                            e.target.files[0]
                                        )
                                    }
                                />

                                {/* Image Preview */}
                                {quizProfileImage && (
                                    <div className="mt-3 text-center">
                                        <img
                                            src={URL.createObjectURL(
                                                quizProfileImage
                                            )}
                                            alt="Preview"
                                            style={{
                                                width: "120px",
                                                height: "120px",
                                                objectFit: "cover",
                                                borderRadius: "12px",
                                                border:
                                                    "2px solid #dee2e6",
                                            }}
                                        />
                                    </div>
                                )}
                            </div>

                            {/* Video */}
                            <div className="mb-4">
                                <label
                                    className="form-label fw-semibold"
                                >
                                    Training Video
                                </label>

                                <input
                                    type="file"
                                    className="form-control"
                                    accept="video/*"
                                    onChange={(e) =>
                                        setQuizVideo(
                                            e.target.files[0]
                                        )
                                    }
                                />

                                {/* Video Preview */}
                                {quizVideo && (
                                    <div className="mt-3">
                                        <video
                                            controls
                                            width="100%"
                                            style={{
                                                borderRadius: "12px",
                                                maxHeight: "300px",
                                                background: "#000",
                                            }}
                                        >
                                            <source
                                                src={URL.createObjectURL(
                                                    quizVideo
                                                )}
                                            />
                                        </video>
                                    </div>
                                )}
                            </div>

                            {/* Button */}
                            <div className="d-grid">
                                <button
                                    className="btn btn-primary"
                                    style={{
                                        padding: "12px",
                                        borderRadius: "12px",
                                        fontWeight: "600",
                                        fontSize: "15px",
                                    }}
                                    onClick={handleQuizAdd}
                                    disabled={loading}
                                >
                                    {loading ? (
                                        <>
                                            <span
                                                className="spinner-border spinner-border-sm me-2"
                                                role="status"
                                            ></span>

                                            Submitting...
                                        </>
                                    ) : (
                                        "Submit"
                                    )}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default QuizAdd;